import { DiGithubAlt } from "react-icons/di";
import { AiOutlineTwitter, AiFillSkype } from "react-icons/ai";
import { GrLinkedinOption } from "react-icons/gr";
import { FaHackerrank } from "react-icons/fa";
import { SiLeetcode, SiHackerrank } from "react-icons/si";

const data = [
  {
    icon: <SiLeetcode style={{ color: "#ffdd00" }} />,
    link: "https://leetcode.com/GhulamAzad/",
  },
  {
    icon: <SiHackerrank style={{ color: "#1ba94c" }} />,
    link: "https://www.hackerrank.com/mdghulamazad",
  },
];

export default data;
